import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { from, throwError } from 'rxjs';
import { catchError, finalize, switchMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { FirebaseService } from '@shared/services/firebase.service';
import { LoaderService } from '@shared/services/loader.service';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const firebaseService = inject(FirebaseService);
  const loaderService = inject(LoaderService);

  if (!req.url.startsWith(environment.baseURL)) {
    return next(req);
  }

  const clientId = environment.clientId;
  const language = localStorage.getItem('language') ?? 'es';

  // Mostrar el loader solo si el método es GET de resto controlarse desde la misma funcion el overlay.
  const shouldShowLoader = req.method === 'GET';
  if (shouldShowLoader && !req.url.includes('nuevas-reservas')) {
    loaderService.show();
  }

  const includeSession = req.url.includes('auth/validate-token');

  if (includeSession) {
    const modifiedRequest = req.clone({
      setHeaders: {
        'X-Language': language,
      },
      setParams: {
        'client-id': clientId,
      },
    });
    return next(modifiedRequest);
  }

  const fbToken = firebaseService.getToken();

  return from(fbToken).pipe(
    switchMap(tokenFirebase => {
      const modifiedRequest = req.clone({
        setHeaders: {
          Authorization: `Bearer ${tokenFirebase}`,
          'X-Language': language,
        },
        setParams: {
          'client-id': clientId,
        },
      });
      return next(modifiedRequest);
    }),
    catchError((err: HttpErrorResponse) => {
      if (err.status === 401 || err.status === 403) {
        firebaseService.doLogout();
      }
      return throwError(() => err);
    }),
    // Cerrar el loader al finalizar la petición (éxito o error)
    finalize(() => {
      if (shouldShowLoader) {
        loaderService.hide();
      }
    })
  );
};
